export const IS_DEVELOPMENT_ENV = process.env.NODE_ENV === 'development';
export const IS_PRODUCTION_ENV = process.env.NODE_ENV === 'production';
export const FORCE_LOCAL_LOCALES = process.env.REACT_APP_FORCE_LOCAL_LOCALES === '1';